
//Packages
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Typography, Button, Box, Stack, useMediaQuery, Modal, TextField, Alert } from '@mui/material';
import { DataGrid, getDataGridUtilityClass, gridClasses, renderActionsCell } from '@mui/x-data-grid'

// Local
import formatName from '../utilities/formatName';
import formatPhoneNumber from '../utilities/formatPhoneNumber';

const AllUsersTableTile = ({ rows, onRowClick }) => {
    /*
        parameters:
            rows: array, each index is a dictionary with one user's information
                {
                    'id': int,
                    'username': str,
                    'firstName': str,
                    'lastName': str,
                    'phoneNumber': str,
                    'email': str,
                    'examTokens': int,
                }
        
        returns:
            User Table copmponent which displays the users given in the rows parameter inside an MUI DataGrid Component
    */

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // DEFINITIONS
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const isMobile = useMediaQuery("(max-width:600px)");

    const paginationModel = { page: 0, pageSize: 10 };

    const gridRows = rows;

    const gridColumns = [
        { flex: 0.5, headerName: 'User ID', field: 'id'},
        { flex: 1, headerName: 'First Name', field: 'first_name', renderCell: (params) => <span>{formatName(params.row.first_name)}</span> },
        { flex: 1, headerName: 'Last Name', field: 'last_name', renderCell: (params) => <span>{formatName(params.row.last_name)}</span> },
        { flex: 1, headerName: 'Phone Number', field: 'phone_number', renderCell: (params) => <span>{formatPhoneNumber(params.row.phone_number)}</span> },
        { flex: 1, headerName: 'Email', field: 'email' },
        { flex: 0.5, headerName: 'Exam Tokens', field:'exam_tokens'},
      ];
    



    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // STYLES 
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const outerBoxStyle = {
        display: 'flex',
        flexDirection: 'column',
        boxShadow: 3,
        borderRadius: 4,
        width:'100%',
        height:'auto',
    };

    const outerBoxStyleMobile = {
        display: 'flex',
        flexDirection: 'column',
        p:2,
        width: '100vw',
        height:'auto',

    };

    const headerStyle = {
        bgcolor: '#3479c8',
        color:'#FFFFFF',
        px:2,
        pt:2,
        borderTopRightRadius:16,
        borderTopLeftRadius:16,
        pb:1,
    }

    const headerTextStyle = {fontWeight:650, textShadow: '2px 2px 4px rgba(0, 0, 0, 0.25)'}

    const gridStyle = {m:1, borderRadius:4, cursor:'pointer'}




    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // HTML COMPONENT
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    return (
        <Box sx={outerBoxStyle}>
            <Box sx={headerStyle}>
                <Typography variant='h4' sx={headerTextStyle}>All Users</Typography>
            </Box>
            <DataGrid
                sx={gridStyle}
                rows={gridRows}
                columns={gridColumns}
                initialState={{ 
                    pagination: { paginationModel },
                    columns: {
                        columnVisibilityModel: {
                            id: true,
                        }
                    },
                    sorting: {
                        sortModel: [{field: 'id', sort:'desc'}]
                    }
                }}
                disableRowSelectionOnClick
                pageSizeOptions={[10, 30, 50, 100]}
                onRowDoubleClick={(params) => {
                    onRowClick(params.row.id)
                    window.scrollTo(0,0);
                }}
            />
        </Box>
    )
}

export default AllUsersTableTile;